import { Controller } from "@hotwired/stimulus"

// Handles activity form UX:
// - Max-height with scroll on the Trix editor so the Save button stays visible
// - Enter submits the form; Shift+Enter inserts a newline
export default class extends Controller {
  connect() {
    this.boundTrixInit = this.trixInitialized.bind(this)
    this.boundKeydown = this.handleKeydown.bind(this)

    const editor = this.element.querySelector("trix-editor")
    if (!editor) return

    this.editor = editor

    if (editor.editor) {
      this.setupEditor()
    } else {
      editor.addEventListener("trix-initialize", this.boundTrixInit, { once: true })
    }
  }

  disconnect() {
    if (this.editor) {
      this.editor.removeEventListener("trix-initialize", this.boundTrixInit)
      this.editor.removeEventListener("keydown", this.boundKeydown)
    }
  }

  trixInitialized() {
    this.setupEditor()
  }

  setupEditor() {
    // Apply max-height and scroll so the form submit button stays visible
    this.editor.style.maxHeight = "8rem"
    this.editor.style.overflowY = "auto"

    this.editor.addEventListener("keydown", this.boundKeydown)
  }

  handleKeydown(event) {
    if (event.key !== "Enter") return
    if (event.shiftKey) return  // Shift+Enter: let Trix insert a newline

    // If a Tribute mention dropdown is open, let Enter select the mention
    if (this.tributeActive()) return

    event.preventDefault()
    event.stopPropagation()

    const form = this.element.closest("form") || this.element.querySelector("form")
    if (form) {
      form.requestSubmit()
    }
  }

  tributeActive() {
    // Tribute appends its menu to the DOM; check if any visible tribute-container exists
    const menu = document.querySelector(".tribute-container")
    return menu && menu.style.display !== "none" && menu.children.length > 0
  }
}
